import React from 'react';
import { Heart, MessageCircle, Info } from 'lucide-react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="app-footer">
      <div className="container footer-container">
        <div className="footer-content">
          <div className="footer-brand">
            <h3>Clean Food CR</h3>
            <p>ยกระดับสุขภาพชาวเชียงราย</p>
          </div>
          <div className="footer-links">
            <a 
              href="https://lin.ee/43CcItl" 
              target="_blank" 
              rel="noopener noreferrer"
              className="footer-line-btn"
            >
              <MessageCircle size={16} /> 
              ติดต่อผ่าน LINE
            </a>
          </div>
        </div>
        <div className="footer-bottom">
          <p>
            <span>ทำด้วย</span>
            <Heart size={14} className="heart-icon" />
            <span>เพื่อคนรักสุขภาพ | © {new Date().getFullYear()}</span>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
